const NF = new Intl.NumberFormat("it-IT", { minimumFractionDigits: 0, maximumFractionDigits: 0 });
const NF2 = new Intl.NumberFormat("it-IT", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export const ND = "n/d";

export const isND = (v) => v === null || v === undefined || Number.isNaN(v);

export function num(v, dec = 0) {
  if (isND(v)) return ND;
  return dec ? NF2.format(v) : NF.format(v);
}

export function eur(v) {
  if (isND(v)) return ND;
  return `€ ${NF2.format(v)}`;
}

export function eurShort(v) {
  if (isND(v)) return ND;
  const a = Math.abs(v);
  if (a >= 1e6) return `${NF2.format(v / 1e6)} Mln €`;
  if (a >= 1e3) return `${NF2.format(v / 1e3)} k€`;
  return `${NF2.format(v)} €`;
}

export const troncaNome = (s = "", max = 30) => (s.length > max ? `${s.slice(0, max).trimEnd()}…` : s);

export function perc(v, dec = 2) {
  if (isND(v)) return ND;
  const s = v > 0 ? "+" : "";
  return `${s}${NF2.format(v)}%`.replace(/^\+?-/, "-");
}

export function dateIt(v) {
  if (!v) return ND;
  const d = new Date(v);
  if (Number.isNaN(d.getTime())) return ND;
  return d.toLocaleDateString("it-IT", { timeZone: "Europe/Rome" });
}

export function dataOraIt(v) {
  if (!v) return ND;
  const d = new Date(v);
  if (Number.isNaN(d.getTime())) return ND;
  return d.toLocaleString("it-IT", {
    timeZone: "Europe/Rome", day: "2-digit", month: "2-digit", year: "numeric",
    hour: "2-digit", minute: "2-digit",
  });
}

export const MESI = ["Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno",
  "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"];

export function statoLabel(s) {
  const m = { APPROVATA: "Approvata", IN_ATTESA: "In attesa", RESPINTA: "Respinta",
    RITIRATA: "Ritirata", LIQUIDATA: "Liquidata", SCONOSCIUTO: "Sconosciuto" };
  return m[s] || s || ND;
}

export function statoClass(s) {
  const m = {
    APPROVATA: "bg-emerald-50 text-emerald-700 border-emerald-200",
    LIQUIDATA: "bg-blue-50 text-blue-700 border-blue-200",
    IN_ATTESA: "bg-amber-50 text-amber-700 border-amber-200",
    RESPINTA: "bg-red-50 text-red-700 border-red-200",
    RITIRATA: "bg-slate-100 text-slate-600 border-slate-200",
  };
  return m[s] || "bg-slate-100 text-slate-600 border-slate-200";
}
